import { colors } from '@src/styles';

export const titleFontFamily = "'Inter Tight', 'Inter', sans-serif";
export const monoFontFamily = "'JetBrains Mono', monospace";

export const skeletonColor = 'rgba(255, 255, 255, 0.06)';

export const profileCardSX = {
  backgroundColor: colors.brand.surface,
  backgroundImage: 'none',
  border: `1px solid ${colors.brand.line}`,
  borderRadius: '14px',
  boxShadow: 'none',
  color: colors.primary.white,
} as const;

export const monoLabelSX = {
  fontFamily: monoFontFamily,
  fontSize: '10px',
  letterSpacing: '0.16em',
  textTransform: 'uppercase',
  color: colors.brand.textMuted,
} as const;

export const cardTitleSX = {
  fontFamily: titleFontFamily,
  fontSize: '15px',
  fontWeight: 600,
  letterSpacing: '-0.01em',
  color: colors.primary.white,
} as const;

export const iconTileSX = {
  width: 32,
  height: 32,
  flexShrink: 0,
  borderRadius: '9px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: colors.primary.yellow,
  backgroundColor: 'rgba(255, 160, 21, 0.12)',
  '& svg': { fontSize: 18 },
} as const;

export const secretFieldSX = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  height: 40,
  paddingLeft: 1.5,
  paddingRight: 0.5,
  backgroundColor: colors.background.primary,
  border: `1px solid ${colors.brand.line}`,
  borderRadius: '8px',
} as const;

export const fieldIconButtonSX = {
  width: 30,
  height: 30,
  color: colors.brand.textSecondary,
  '& svg': { fontSize: 17 },
  '&:hover': { color: colors.primary.yellow, backgroundColor: 'rgba(255, 160, 21, 0.1)' },
} as const;

export const outlineButtonSX = {
  height: 40,
  paddingX: 1.75,
  flexShrink: 0,
  borderRadius: '8px',
  border: '1px solid rgba(255, 160, 21, 0.5)',
  backgroundColor: 'rgba(255, 160, 21, 0.08)',
  color: colors.primary.yellow,
  fontFamily: titleFontFamily,
  fontSize: '13px',
  fontWeight: 600,
  textTransform: 'none',
  whiteSpace: 'nowrap',
  '& .MuiButton-startIcon svg': { fontSize: 17 },
  '&:hover': { backgroundColor: 'rgba(255, 160, 21, 0.16)', borderColor: colors.primary.yellow },
  '&.Mui-disabled': { color: 'rgba(255, 160, 21, 0.5)', borderColor: 'rgba(255, 160, 21, 0.25)' },
} as const;

export const tonePillSX = (color: string) =>
  ({
    display: 'inline-flex',
    alignItems: 'center',
    height: 22,
    paddingX: 1,
    borderRadius: '999px',
    border: `1px solid ${color}55`,
    backgroundColor: `${color}14`,
    color,
    fontFamily: monoFontFamily,
    fontSize: '10px',
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  }) as const;
